


































import { Component, Vue } from 'vue-property-decorator';
import { Table } from 'element-ui';
import { requiredOnChange } from '@/shared/validation/rule';
import { IProductInfo } from '../../shared/models';
import CreateForm from './components/CreateForm.vue';

@Component({
  name: 'Products',
  components: {
    CreateForm,
  },
})
export default class Products extends Vue {
  isLoading = false;

  selectedProductId: number | null = null;

  private dialogVisible = false;

  public listProduct: IProductInfo[] = [];

  protected created() {
    this.fetch();
  }

  protected handleCurrentChange(val: IProductInfo) {
    this.selectedProductId = val ? val.id || null : null;
  }

  protected clearSelect() {
    if (this.$refs.productTable) (this.$refs.productTable as Table).setCurrentRow(undefined);
  }

  private async fetch() {
    this.clearSelect();
    this.isLoading = true;
    this.listProduct = await this.$api.products.getListProduct();
    this.isLoading = false;
  }

  private async create(form: any) {
    this.isLoading = true;
    await this.$api.products.createProduct(form);
    this.isLoading = false;
    this.dialogVisible = false;
    this.fetch();
  }
}
